<template>
  <div class="x-loading-bar">
    <div
      ref="bar-inner"
      :class="['x-loading-bar-inner', animationClass, color]"
    />
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
/**
 * @deprecated Use `<ys-loading-bar>` from the latest `@onxmaps/yellowstone-ui` release instead.
 */
export default {
  name: 'XLoadingBar',
  inject: {
    theme: { default: 'hunt' },
  },
  props: {
    duration: {
      type: Number,
      default: undefined,
    },
    numSteps: {
      type: Number,
      default: undefined,
    },
    currentStep: {
      type: Number,
      default: undefined,
    },
    completed: {
      type: Boolean,
      required: true,
    },
    timeToHide: {
      type: Number,
      default: undefined,
    },
    color: {
      type: String,
      default: 'theme',
      validator: (value) => {
        return ['theme', 'grey', 'error'].includes(value)
      },
    },
  },
  computed: {
    progressPercent() {
      if (this.numSteps) {
        return (this.currentStep / this.numSteps) * 100
      }

      return 100
    },
    animationClass() {
      if (this.completed) {
        return ''
      }
      return this.duration ? 'determinate' : 'indeterminate'
    },
  },
  watch: {
    completed() {
      // get width at loading completed
      const firstAnimation = this.$refs['bar-inner'].getAnimations()[0]
      const { currentTime } = firstAnimation?.timeline ?? {}
      let percentDone
      if (!this.numSteps) {
        percentDone = currentTime / (this.duration * 1000)
      } else {
        percentDone = (this.currentStep / this.numSteps) * 100
      }
      const maxLoadWidth = 80
      const currentLoadWidth = percentDone * maxLoadWidth

      // stop loading animation
      this.$refs['bar-inner'].style.animation = 'none'
      this.$refs['bar-inner'].style.width = `${currentLoadWidth}%`

      // set finish animation
      setTimeout(() => this.$el.classList.add('completed'), 0)

      // set hiding aninmation
      if (this.timeToHide) {
        setTimeout(() => this.$el.classList.add('hide'), this.timeToHide * 1000)
      }
    },
  },
  mounted() {
    if (this.duration) {
      this.$refs['bar-inner'].style.animationDuration = `${this.duration}s`
    }
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '@/styles/system/_themes.scss';
@use '@/styles/system/_colors.scss';

.x-loading-bar {
  height: 3px;
  background: colors.$Grey20;
  opacity: 1;
  transition: opacity 0.075s;
  overflow: hidden;

  .x-loading-bar-inner {
    width: calc(v-bind(progressPercent) * 1%);
    height: 100%;
  }

  .theme {
    background: var(--ys-color-brand-primary);
  }
  .grey {
    background: colors.$Grey90;
  }

  .error {
    background: colors.$TertiaryRedDarken;
  }

  .determinate {
    animation-name: determinateProgressBar;
    animation-fill-mode: both;
    transition: width 0.5s ease;
    transform-origin: top left;
  }
  .indeterminate {
    animation: indeterminateProgressBar 2s ease-in 0.5s infinite;
    transform-origin: top left;
    animation-fill-mode: both;
  }
}

.x-loading-bar.completed {
  .x-loading-bar-inner {
    width: 100% !important;
  }
}

.x-loading-bar.hide {
  opacity: 0;
}

@keyframes determinateProgressBar {
  0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
}

@keyframes indeterminateProgressBar {
  0% {
    transform: scaleX(0.15) translateX(-200%);
  }
  to {
    transform: scaleX(0.25) translateX(500%);
  }
}
</style>
